var _path, _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 99,
    viewBox: "0 0 106 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4462 6.09662L19.0598 15.0425C6.89329 18.3025 1.84688 27.0422 5.10658 39.2075L14.0431 72.559C17.3028 84.7244 26.043 89.77 38.2095 86.51L71.5959 77.5641C83.7624 74.3041 88.777 65.5729 85.5173 53.4076L76.5808 20.0561C73.3211 7.89072 64.6127 2.83662 52.4462 6.09662Z",
    fill: "url(#paint0_linear_21_174)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_21_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3329 20.8696L28.2656 26.7825C20.224 28.9372 16.8295 34.4941 18.8801 42.1469L24.5018 63.1275C26.5524 70.7803 32.2705 73.8955 40.3121 71.7407L62.3794 65.8278C70.4211 63.6731 73.7945 58.1219 71.7439 50.469L66.1222 29.4885C64.0716 21.8356 58.3745 18.7148 50.3329 20.8696Z",
    fill: "#0F0D24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_21_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.7002 23.6476H43.6262C31.0851 23.6476 22.6504 32.4522 22.6504 45.5482V75.7726C22.6504 88.8315 31.0851 97.6362 43.6262 97.6362H75.7002C88.2413 97.6362 96.639 88.8315 96.639 75.7726V45.5482C96.639 32.4522 88.2413 23.6476 75.7002 23.6476Z",
    fill: "#FAFAFF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7002 23.1476H43.6262C37.2342 23.1476 31.8548 25.3941 28.0743 29.341C24.2956 33.2861 22.1504 38.8918 22.1504 45.5482V75.7726C22.1504 82.4108 24.2958 88.0073 28.0745 91.9476C31.8549 95.8897 37.2343 98.1362 43.6262 98.1362H75.7002C82.0922 98.1362 87.4626 95.8896 91.2338 91.9471C95.0032 88.0066 97.139 82.4102 97.139 75.7726V45.5482C97.139 38.8924 95.0034 33.2868 91.234 29.3415C87.4627 25.3942 82.0922 23.1476 75.7002 23.1476Z",
    stroke: "url(#paint1_linear_21_174)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_21_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.564 18.212C97.5617 18.212 95.1279 20.6458 95.1279 23.6479C95.1279 26.6501 97.5617 29.0838 100.564 29.0838C103.566 29.0838 106 26.6501 106 23.6479C106 22.2062 105.427 20.8236 104.408 19.8042C103.388 18.7847 102.006 18.212 100.564 18.212Z",
    fill: "url(#paint2_linear_21_174)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_21_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9999 54.0903L68.4275 67.7331C67.9827 68.3261 67.3155 68.7129 66.5793 68.8048C65.8431 68.8967 65.1011 68.6857 64.5238 68.2203L54.3743 60.262L45.2333 72.0858C44.5713 73.1369 43.2821 73.6092 42.0964 73.2349C40.9107 72.8607 40.1277 71.7342 40.1911 70.4941V70.4941C40.1856 69.8805 40.3924 69.2839 40.7766 68.805L51.7069 54.7075C52.1463 54.1192 52.8046 53.7326 53.533 53.6348C54.2614 53.537 54.9985 53.7363 55.578 54.1877L65.7275 62.1785L74.6408 50.7121C75.0693 50.1209 75.7196 49.7284 76.443 49.6244C77.1664 49.5203 77.9012 49.7135 78.4794 50.1599C79.674 51.0942 79.905 52.8091 78.9999 54.0253V54.0903Z",
    fill: "url(#paint3_linear_21_174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5596 53.833C54.2346 53.7424 54.9177 53.927 55.4547 54.3452C55.4548 54.3453 55.4549 54.3454 55.4551 54.3455L65.6037 62.3357L65.7619 62.4601L65.8854 62.3013L74.7987 50.8348L74.7988 50.8349L74.8027 50.8295C75.1995 50.2821 75.8016 49.9187 76.4715 49.8223C77.1411 49.726 77.8212 49.9048 78.3565 50.3177C79.4654 51.1852 79.6795 52.777 78.8394 53.9059L78.7999 53.9591V54.0219L68.2694 67.6106L68.2694 67.6106L68.2675 67.6131C67.8553 68.1626 67.237 68.5212 66.5546 68.6064C65.8721 68.6915 65.1844 68.496 64.6494 68.0646L64.6472 68.0629L54.4978 60.1046L54.3393 59.9804L54.2161 60.1397L45.0751 71.9634L45.0692 71.9711L45.0641 71.9792C44.4506 72.9533 43.2557 73.3912 42.1566 73.0442C41.0576 72.6973 40.3321 71.6533 40.3908 70.5043L40.1911 70.4941L40.3911 70.4923C40.386 69.9249 40.5773 69.3731 40.9326 68.9302L40.9327 68.9302L40.9347 68.9276L51.8649 54.83L51.8649 54.83L51.8671 54.8272C52.2743 54.2821 52.8844 53.9237 53.5596 53.833Z",
    stroke: "url(#paint4_linear_21_174)",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_21_174",
    x: 1.29541,
    y: 3.203,
    width: 88.0352,
    height: 86.2049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_21_174"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_21_174",
    x: -2.34961,
    y: -1.35242,
    width: 123.989,
    height: 123.989,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21_174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_21_174",
    x: 80.1279,
    y: 3.21204,
    width: 40.8718,
    height: 40.8718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21_174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_21_174",
    x: 25.1875,
    y: 34.5968,
    width: 69.3645,
    height: 53.7653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21_174"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.157065 0 0 0 0 0.140278 0 0 0 0 0.333333 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_21_174",
    result: "effect2_dropShadow_21_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_21_174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_174",
    x1: 51.8562,
    y1: 49.6834,
    x2: -2.7625,
    y2: 97.0493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_174",
    x1: 34.4282,
    y1: 32.2674,
    x2: 81.625,
    y2: 90.7218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_174",
    x1: 101.364,
    y1: 24.376,
    x2: 91.8113,
    y2: 29.0208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#837AE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21_174",
    x1: 76.7612,
    y1: 53.8883,
    x2: 32.9938,
    y2: 56.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21_174",
    x1: 46.4537,
    y1: 52.3655,
    x2: 58.6698,
    y2: 77.4266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart1);
export default __webpack_public_path__ + "static/media/chart1.fdaae2e0062c68f96adbb5a50eb48443.svg";
export { ForwardRef as ReactComponent };